import subwayfirstdish from "../assets/dishes/subwayfirstdish.png";
import subwayseconddish from "../assets/dishes/subwayseconddish.png";
import subwaythirddish from "../assets/dishes/subwaythirddish.png";
import subwayfourthdish from "../assets/dishes/subwayfourthdish.png";
import subwayfifthdish from "../assets/dishes/subwayfifthdish.png";
import mcdfirstdish from "../assets/dishes/mcdfirstdish.png";
import mcdseconddish from "../assets/dishes/mcdseconddish.png";
import mcdthirddish from "../assets/dishes/mcdthirddish.png";
import mcdfourthdish from "../assets/dishes/mcdfourthdish.png";
import mcdfifthdish from "../assets/dishes/mcdfifthdish.png";
import califorfirstdish from "../assets/dishes/califorfirstdish.png";
import califorseconddish from "../assets/dishes/califorseconddish.png";
import califorthirddish from "../assets/dishes/califorthirddish.png";
import califorfourthdish from "../assets/dishes/califorfourthdish.png";
import califorfifthdish from "../assets/dishes/califorfifthdish.png";
import a2bfirstdish from "../assets/dishes/a2bfirstdish.png";
import a2bseconddish from "../assets/dishes/a2bseconddish.png";
import a2bthirddish from "../assets/dishes/a2bthirddish.png";
import a2bfourthdish from "../assets/dishes/a2bfourthdish.png";
import a2bfifthdish from "../assets/dishes/a2bfifthdish.png";
import theofirstdish from "../assets/dishes/theofirstdish.png";
import theoseconddish from "../assets/dishes/theoseconddish.png";
import empirefirstdish from "../assets/dishes/empirefirstdish.png";
import empireseconddish from "../assets/dishes/empireseconddish.png";
import pizzahfirstdish from "../assets/dishes/pizzagarlicfirstdish.png";
import pizzaseconddish from "../assets/dishes/pizzaseconddish.png";
import nicseconddish from "../assets/dishes/nicseconddish.png";
import nicfirstdish from "../assets/dishes/nicfirstdish.png";
import leonseconddish from "../assets/dishes/leonseconddish.png";
import leonfirstdish from "../assets/dishes/leonfirstdish.png";
import burgerkfirstdish from "../assets/dishes/burgerkfirstdish.png";
import burgerkseconddish from "../assets/dishes/burgerkseconddish.png";
import trufflesfirstdish from "../assets/dishes/trufflesfirstdish.png";
import trufflesseconddish from "../assets/dishes/trufflesseconddish.png";
import hssfirstdish from "../assets/dishes/hssfirstdish.png";
import hssseconddish from "../assets/dishes/hssseconddish.png";
import kfcfirstdish from "../assets/dishes/kfcfirstdish.png";
import kfcseconddish from "../assets/dishes/kfcseconddish.png";
import upaharafirstdish from "../assets/dishes/upaharadfirstdish.png";
import upaharaseconddish from "../assets/dishes/upaharaseconddish.png";
import wowmfirstdish from "../assets/dishes/wowmfirstdish.png";
import wowmseconddish from "../assets/dishes/wowmseconddish.png";

export const resMenu = [
  {
    restaurantId: "69876",

    id: "1",
    restaurantName: "Subway",
    firstItem: "Delhi Tikki Sandwich + Side + Coke",
    firstDescription:
      "Enjoy your favourite Grills sandwich with a choice of drink and a cookie or veg kebabs.",
    firstItemCost: "₹279",
    firstCloudinaryimageid: subwayfirstdish,

    secondItem: "Bombay Grill Sandwich + Side + Coke",
    secondDescription:
      "Enjoy your favourite Grills sandwich with a choice of drink and a cookie or veg kebabs.",
    secondItemCost: "₹279",
    secondCloudinaryimageid: subwayseconddish,

    // thirdItem: "3 Cheese Melt Sandwich + Side + Coke",
    // thirdDescription:
    //   "Enjoy your favourite Grills sandwich with a choice of drink and any choice of side.",
    // thirdItemCost: "₹289",
    // thirdCloudinaryimageid: subwaythirddish,

    // fourthItem: "Paneer Achari Sandwich + Side + Coke",
    // fourthDescription:
    //   "Enjoy your favourite Hotseller sub with a choice of cookie and a choice of drink.",
    // fourthItemCost: "₹379",
    // fourthCloudinaryimageid: subwayfourthdish,

    // fifthItem: "Crunchy Mexican Sandwich + Side + Coke",
    // fifthDescription:
    //   "Enjoy your favourite Hotseller sub with a choice of cookie and a choice of drink.",
    // fifthItemCost: "₹359",
    // fifthCloudinaryimageid: subwayfifthdish,
  },

  {
    restaurantId: "43836",

    id: "2",
    restaurantName: "McD",
    firstItem: "2 McAloo Tikki Burger + 2 Fries (L)",
    firstDescription:
      "Enjoy your favourite Grills sandwich with a choice of drink and a cookie or veg kebabs.",
    firstItemCost: "₹329",
    firstCloudinaryimageid: mcdfirstdish,

    secondItem: "Burger Combo for 2: McVeggie Burger with Pizza McPuff",
    secondDescription:
      "Save big on your favourite sharing combo - 2 McVeggie Burger + 2 Fries (M) + Veg Pizza McPuff",
    secondItemCost: "₹389",
    secondCloudinaryimageid: mcdseconddish,

    thirdItem:
      "McSpicy Paneer Burger + 2 Fries M + McAloo Tikki + Veg Pizza McPuff",
    thirdDescription:
      "Get the best value in your meal for 2. Save big on your favourite sharing meal - McSpicy Paneer Burger + 2 Fries (M) + McAloo Tikki Burger + Veg Pizza McPuff",
    thirdItemCost: "₹359",
    thirdCloudinaryimageid: mcdthirddish,

    fourthItem:
      "McSpicy Paneer Burger + McAloo Tikki Burger + Fries (L) + 2 Coke",
    fourthDescription:
      "Get the best value in your meal for 2. Save big on your favourite sharing meal - McSpicy Paneer Burger + Fries (L) + 2 Coke + McAloo Tikki Burger",
    cost: "₹329",
    fourthCloudinaryimageid: mcdfourthdish,

    fifthItem: "McVeggie Burger + McAloo Tikki Burger + Fries (L) + 2 Coke",
    fifthDescription:
      "Get the best value in your meal for 2. Save big on your favourite sharing meal - McVeggie Burger + Fries (L) + 2 Coke + McAloo Tikki Burger",
    cost: "₹389",
    fifthCloudinaryimageid: mcdfifthdish,
  },

  {
    restaurantId: "16073",

    id: "3",
    restaurantName: "California Burrito",
    firstItem: "Rice bowl",
    firstDescription: "Barbeque Paneer Rice Bowl (Regular)",
    description:
      "Serves 1 | Fresh cilantro rice and everything nice. Comes with your favourite toppings, fajita veggies like bell peppers and onions, pico de galla and BBQ Paneer.",
    firstItemCost: "₹309",
    firstCloudinaryimageid: califorfirstdish,

    secondItem: "Crispy Mushroom Rice Bowl (Regular)",
    secondDescription:
      "Serves 1 | Fresh cilantro rice and everything nice. Comes with your favourite toppings, fajita veggies like bell peppers and onions, pico de galla and crispy mushroom",
    secondItemCost: "₹299",
    secondCloudinaryimageid: califorseconddish,
  },

  {
    restaurantId: "16304",

    id: "4",
    restaurantName: "A2B",
    firstItem: "Rava Idly",
    firstDescription:
      "Serves 1 | Rava idly [1Nos] (also rave idly) is a variation of the popular South Indian breakfast item idly, made with Rava and curd Serve with aloo sagu and coconut chutney",
    firstItemCost: "₹90",
    firstCloudinaryimageid: a2bfirstdish,

    secondItem: "Ghee Pongal",
    secondDescription:
      "Serves 1 | A savory dish made of cooked rice and green gram blended with clarified butter,mildly tempered with spices, garnished with cashews and servedhot",
    secondItemCost: "₹110",
    secondCloudinaryimageid: a2bseconddish,

    thirdItem: "Mini Tiffin",
    thirdDescription:
      "Serves 1 | A delicious traditional platter of fluffy idlis, Medhu Vada, Pongal, Rava Kesari, and a Mini Dosa, served with a spicy sambar and chutneys.",
    thirdItemCost: "₹180",
    thirdCloudinaryimageid: a2bthirddish,

    fourthItem: "Rava Onion Masala",
    fourthDescription:
      "Serves 1 | A delicious textured dosa made of semolina, rice and all-purpose flour batter with chopped chilies, onions, pepper corns and coriander served with sambar and chutney.",
    fourthItemCost: "₹150",
    fourthCloudinaryimageid: a2bfourthdish,

    fifthItem: "Medhu Vadai",
    fifthDescription:
      "Serves 1 | Crispy donut-shaped deep-fried fritters made of ground black lentil batter mixed with finely diced onions, peppercorn, green chilies served with a spicy sambar and chutney",
    fifthItemCost: "₹70",
    fifthCloudinaryimageid: a2bfifthdish,
  },

  {
    restaurantId: "11551",

    id: "5",
    restaurantName: "Theobroma",
    firstItem: "Eggless Dutch Truffle Cake [1/2kg]",
    firstDescription: "Dark chocolate ganache with chocolate sponge.",
    firstItemCost: "₹625",
    firstCloudinaryimageid: theofirstdish,

    secondItem: "Chocoholic Cake [1/2kg]",
    secondDescription:
      "Three layers of chocolate mousse: white, milk and dark chocolate mousse layered in this crowd-favourite cake.",
    secondItemCost: "₹725",
    secondCloudinaryimageid: theoseconddish,
  },

  {
    restaurantId: "15199",

    id: "6",
    restaurantName: "Hotel Empire",
    firstItem: "Empire Special Chicken Kebab",
    firstDescription: "Empire Special Chicken Kebab Empire Classic Dry",
    firstItemCost: "₹110",
    firstCloudinaryimageid: empirefirstdish,

    secondItem: "Chicken Biryani (Regular), Raita & Popcorn Kebab",
    secondDescription:
      "Chicken Biriyani (Regular), Raitha, Popcorn Kebab (5 Pcs)",
    secondItemCost: "₹215",
    secondCloudinaryimageid: empireseconddish,
  },

  {
    restaurantId: "15190",

    id: "7",
    restaurantName: "Burger King",
    firstItem: "Crispy Veg Burger",
    firstDescription:
      "Masaledar Veg Patty, Onion & Our Signature Tomato Herby Sauce. ",
    firstItemCost: "₹150",
    firstCloudinaryimageid: burgerkfirstdish,

    secondItem: "King Fries",
    secondDescription: "The Perfect Crispy Partner",
    secondItemCost: "₹130",
    secondCloudinaryimageid: burgerkseconddish,
  },

  {
    restaurantId: "33699",

    id: "8",
    restaurantName: "Truffles",
    firstItem: "Caesar salad",
    firstDescription: "Dark chocolate ganache with chocolate sponge.",
    firstItemCost: "₹625",
    firstCloudinaryimageid: trufflesfirstdish,

    secondItem: "Aglio pasta",
    secondDescription:
      "Three layers of chocolate mousse: white, milk and dark chocolate mousse layered in this crowd-favourite cake.",
    secondItemCost: "₹725",
    secondCloudinaryimageid: trufflesseconddish,
  },

  {
    restaurantId: "15015",

    id: "9",
    restaurantName: "Hari Super Sandwich",
    firstItem: "Masala Puri",
    firstDescription:
      "A delighylly flavorful dish of crispy puris crushed and mixed with tasty peas gravy, chaat chutney, onions and more.",
    firstItemCost: "₹70",
    firstCloudinaryimageid: hssseconddish,

    secondItem: "American Sweet corn Sandwich",
    secondDescription:
      "A delicious sandwich made by toasted fresh bread layered with cheese and stuffed with mixed vegetables and sweet corn.",
    secondItemCost: "₹100",
    secondCloudinaryimageid: hssfirstdish,
  },
  {
    restaurantId: "15555",

    id: "10",
    restaurantName: "Naturals Ice cream",
    firstItem: "Chocobite Ice Cream",
    firstDescription:
      "Serves 1 | Have a weakness for chocolate? Then you’ll fall in love with our original Choco Bite ice cream. It’s made from coco mass sourced from Ghana. You’ll even find hand-cut chocolate chunks in this flavour, making it truly hard to resist.",
    firstItemCost: "₹80",
    firstCloudinaryimageid: nicfirstdish,

    secondItem: "Roasted Almond Ice Cream",
    secondDescription:
      "Serves 1 | The almonds are sourced from California. But the inimitable taste of this delicious flavour is our very own! ",
    secondItemCost: "₹100",
    secondCloudinaryimageid: nicseconddish,
  },

  {
    restaurantId: "11115",

    id: "11",
    restaurantName: "Leon's - Burgers and Wings",
    firstItem: "Veg burger",
    firstDescription: "Grilled cheese burger loaded wih cheese",
    firstItemCost: "₹555",
    firstCloudinaryimageid: leonfirstdish,

    secondItem: "Burger+Coke+Fries",
    secondDescription: "A combo box which provides a delicious meal",
    secondItemCost: "₹725",
    secondCloudinaryimageid: leonseconddish,
  },
  {
    restaurantId: "55551",

    id: "12",
    restaurantName: "KFC",
    firstItem: "Veg Zinger Burger with Cheese",
    firstDescription:
      "Signature veg burger with crispy patties, cheese slice, veggies & a tangy sauce",
    firstItemCost: "₹215",
    firstCloudinaryimageid: kfcfirstdish,

    secondItem: "Veg Box Meal",
    secondDescription:
      "Enjoy special Veg Box Meal with savings of ₹ 101 on Veg Zinger Burger, 2 Pc Veg patty, Medium Fries & a Pepsi PET 475ml",
    secondItemCost: "₹399",
    secondCloudinaryimageid: kfcseconddish,
  },
  {
    restaurantId: "15151",

    id: "13",
    restaurantName: "Pizza Hut",
    firstItem: "Grarlic Bread",
    firstDescription:
      "Grilled chilly cheese garlic bread with loads of cheese and mayo",
    firstItemCost: "₹222",
    firstCloudinaryimageid: pizzahfirstdish,

    secondItem: "Cheese Pizza",
    secondDescription: "Grilled chilly cheese pizza with loads of cheese",
    secondItemCost: "₹555",
    secondCloudinaryimageid: pizzaseconddish,
  },
  {
    restaurantId: "69696",

    id: "14",
    restaurantName: "Wow momos",
    firstItem: "Corn Cheese Pan Fried Momo in Schezwan Sauce (Spicy)",
    firstDescription:
      "Hot & crispy Corn Cheese fried Momo, tossed in spicy Schezwan sauce and garnished with coriander We don't serve additional Sauce with this plate of Momos [5Pcs].",
    firstItemCost: "₹222",
    firstCloudinaryimageid: wowmseconddish,

    secondItem: "Chatpata Paneer Steam Momo",
    secondDescription:
      "Savor the goodness of Delicious Momos, filled with freshly chopped Veggies, Paneer, a hint of spices, and blended with Indian Masala. Accompanied by our tantalizing Spicy Red Sauce [5pcs]",
    secondItemCost: "₹333",
    secondCloudinaryimageid: wowmfirstdish,
  },
  {
    restaurantId: "96969",

    id: "9",
    restaurantName: "Upahara Darshini",
    firstItem: "Stuffed Naan",
    firstDescription: "Naan cooked with lots garlic and butter",
    firstItemCost: "₹150",
    firstCloudinaryimageid: upaharafirstdish,

    secondItem: "Gobi Manchurian",
    secondDescription:
      "deep-fried, crispy Cauliflower tossed in a thick and spicy manchurian gravy.",
    secondItemCost: "₹725",
    secondCloudinaryimageid: upaharaseconddish,
  },
];
